import { FC, useEffect, useState } from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { AddLeadingZero } from "src/utils/utils";
import { useStore, connect } from 'src/store/connect';
import { EMPTY_OUTGOING_MESSAGE_PLACEHOLDER } from "src/config/constants"

interface MultipleOptionsBlockProps {
  id: string;
  data: NodeData;
}

const MultipleOptionsBlock: FC<MultipleOptionsBlockProps> = ({ id, data }) => {
  const classes = useStyles();
  const state = useStore();
  const [targets, setTargets] = useState<NodeReactFlow[]>([])

  useEffect(() => {
    const sourceTargets = state.getTargets(id)
    if (!sourceTargets || sourceTargets.length === 0) {
      return
    }
    setTargets(sourceTargets)
  }, [state.flow.edges, state.flow, state.flow.nodes]);

  return (
    <div className={classes.root}>
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={false}
      />
      <div className={`${(!data.highlighted && state.simulationRunning)? classes.opacity : ''}`}>
        {
          data.outgoingMessage && data.outgoingMessage !== ''? <Typography className={classes.label}>{data.outgoingMessage}</Typography>
          : <Typography className={classes.labelEmpty}>{EMPTY_OUTGOING_MESSAGE_PLACEHOLDER}</Typography>
        }
        {
          data.variable?.key && data.variable?.key !== '' && <Typography className={classes.labelVariable}>
            variable: <span className={classes.variable}>{`{{ ${data.variable?.key} }}`}</span>
          </Typography>
        }
        <Typography className={classes.type}>
          Múltiples respuestas
        </Typography>
        {targets.map((node) => {
          return (
            <div className={classes.optionContainer} key={`option-${node.id}`}>
              <span style={getOptionIndicatorStyle(node.data?.strokeColor)} />
              <div className={classes.displayFlex}>
                <Typography className={classes.options}>
                  {node.data?.order && AddLeadingZero(node.data?.order)}
                </Typography>
                {
                  node.data?.incomingMessage && node.data?.incomingMessage !== ''? <Typography className={classes.options}>{node.data?.incomingMessage}</Typography>
                  : <Typography className={`${classes.options} ${classes.labelEmpty}`}>{EMPTY_OUTGOING_MESSAGE_PLACEHOLDER}</Typography>
                }
              </div>
            </div>
          );
        })}
      </div>
      {/* TODO: fix id generation */}
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={false}
      />
    </div>
  );
};

const getOptionIndicatorStyle = (strokeColor: string) => {
  return {
    width: "8px",
    height: "38px",
    borderRadius: "2.5px",
    backgroundColor: strokeColor,
  };
};

export default connect(MultipleOptionsBlock);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "186px",
    padding: "21px 20px 19px 21px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "solid 1px #eff2f8",
    backgroundColor: "#ffffff",
  },
  label: {
    margin: "0 0 0px",
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
  },
  labelVariable: {
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
    marginTop: "10px",
  },
  variable: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0091ff",
    overflowWrap: "break-word",
  },
  opacity: {
    opacity: 0.36,
    filter: "grayscale(1)",
  },
  labelEmpty: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#445561"
  },
  type: {
    margin: "9px 21px 27px 0",
    opacity: "0.57",
    fontSize: "14px",
  },
  options: {
    margin: "0 0 0 17px",
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
    maxWidth: "120px",
  },
  optionContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: "9px",
  },
  displayFlex: {
    display: "flex",
    alignItems: "center",
  }
}));
